import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { bookReducer } from "./book.reducer";
import { BookEffect } from "./book.effects";

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature("books", bookReducer),
        EffectsModule.forFeature([BookEffect]),
    ],
    providers: []
})
export class BookStateModule { }
